<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              Pedidos a receber
            </div>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                api_model="VrtTransaction" 
                action="VrtTransactions"
                :filters="local_filter"
              ></BtnCreateDataExport>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="onHeaderRefreshToReceive">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text>
            <router-view @localFilter="handleLocalFilter"></router-view>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
  </div>
</template>

<script>
export default {
  name: 'ToReceiveOrders',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  provide() {
    const vm = this
    return {
      registerToReceiveListReload(fn) {
        vm.toReceiveListReload = fn
      },
    }
  },
  data(){
    return {
      local_filter: {},
      toReceiveListReload: null,
    }
  },
  methods: {
    handleLocalFilter(d){
      this.local_filter = d
    },
    onHeaderRefreshToReceive() {
      if (this.toReceiveListReload) this.toReceiveListReload()
    },
  },
  created () {
    this.$router.push({name:'ToReceivePayments'});
  },
}
</script>
